import type { MultipartFileStatusType, UploadedFileStepType } from '@core/core/types'
import cn from 'classnames'
import type { FC } from 'react'

import css from './Steps.css'

type ProgressStepBarPropsType = {
  step: UploadedFileStepType
  status: MultipartFileStatusType
}

export const ProgressStepBar: FC<ProgressStepBarPropsType> = ({ status }) => {
  const className = cn(css.stepsLine, {
    [css.default]: status === 'inprogress' || status === 'succeeded' || status === 'paused',
    //[css.pause]: status === 'paused',
    [css.ready]: status === 'ready',
    [css.error]: status === 'failed',
  })

  return <div className={className} />
}
